var map = {
	"./AllStop, Pedestrian Controller.pdf": 1266,
	"./AllStop.pdf": 1267,
	"./DiverttoOtherFootway.pdf": 1268,
	"./FootwayOpen.pdf": 1269,
	"./GiveAndTake, Divert Pedestrian.pdf": 1270,
	"./GiveAndTake, Footway Open.pdf": 1271,
	"./GiveAndTake, Pedestrian Route.pdf": 1272,
	"./GiveAndTake.pdf": 1273,
	"./Marshall.pdf": 1274,
	"./Multi-Lane.pdf": 1275,
	"./PedestrianRoutePastWorks.pdf": 1276,
	"./Priority.pdf": 1277,
	"./Roundabout.pdf": 1278,
	"./SemiStatic.pdf": 1279,
	"./StopGo, Divert Pedestrian.pdf": 1280,
	"./StopGo, Footway Open.pdf": 1281,
	"./StopGo, Pedestrian Route.pdf": 1282,
	"./StopGo.pdf": 1283,
	"./TrafficSignals.pdf": 1284,
	"./TwoWay, Footway Open.pdf": 1285,
	"./TwoWay.pdf": 1286,
	"./VergeWorks.pdf": 1287
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1030;